import { useEffect, useRef } from "react";
import { Bot, User2, Loader2 } from "lucide-react";
import { MiniMd } from "./MiniMd";

export const AssistMessages = ({ messages, busy, t, onSuggest }) => {
  const end = useRef(null);
  useEffect(() => { end.current?.scrollIntoView({ block: "end" }); }, [messages, busy]);
  if (!messages.length) {
    return (
      <div className="p-5 space-y-4" data-testid="assist-empty">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 rounded-lg bg-[#a746ff]/20 grid place-items-center shrink-0"><Bot className="w-4 h-4 text-[#c79bff]" /></div>
          <p className="text-sm text-slate-300 leading-relaxed">{t("as.hello")}</p>
        </div>
        <div className="flex flex-col gap-2 pl-11">
          {["as.q1", "as.q2", "as.q3", "as.q4"].map((k) => (
            <button key={k} onClick={() => onSuggest(t(k))} data-testid={`assist-suggest-${k.slice(3)}`}
              className="text-left text-xs rounded-lg border border-white/10 px-3 py-2 text-slate-300 hover:border-[#2f7bff]/60 hover:text-white transition-colors">{t(k)}</button>
          ))}
        </div>
      </div>
    );
  }
  return (
    <div className="p-4 space-y-4" data-testid="assist-messages">
      {messages.map((m, i) => (
        <div key={i} className={`flex gap-2.5 ${m.role === "user" ? "flex-row-reverse" : ""}`} data-testid={`assist-msg-${m.role}-${i}`}>
          <div className={`w-7 h-7 rounded-lg grid place-items-center shrink-0 ${m.role === "user" ? "bg-[#2f7bff]/20" : "bg-[#a746ff]/20"}`}>
            {m.role === "user" ? <User2 className="w-3.5 h-3.5 text-[#7fb0ff]" /> : <Bot className="w-3.5 h-3.5 text-[#c79bff]" />}
          </div>
          <div className={`max-w-[82%] rounded-xl px-3.5 py-2.5 text-[13px] leading-relaxed ${m.role === "user" ? "bg-[#2f7bff]/15 text-white" : m.error ? "bg-[#ff4d6d]/10 text-[#ff9aac]" : "bg-white/[0.04] text-slate-300"}`}>
            {m.role === "user" ? m.text : m.text ? <MiniMd text={m.text} /> : <Loader2 className="w-4 h-4 animate-spin text-slate-500" />}
          </div>
        </div>
      ))}
      {busy && messages[messages.length - 1]?.role === "user" && <Loader2 className="w-4 h-4 animate-spin text-slate-500 ml-10" />}
      <div ref={end} />
    </div>
  );
};
